import { SelectButtonItem } from "../models/select-button-item";

export class SelectButtonOptionClickEvent<Value> {
  constructor(readonly originalEvent?: Event, readonly option?: SelectButtonItem<Value>, readonly index?: number) {

  }
}
